import { atom } from "recoil";

export const choicesState = atom({
    key: 'choicesState',
    default: {
        activities: Array.from({ length: 48 }, (_, i) => 0),
        tenPersonalItemInventory: Array.from({ length: 10 }, (_, i) => 0),
        wordDefinitions: Array.from({ length: 16 }, (_, i) => -1),
    }
})

export const predictionState = atom({
    key: 'predictionState',
    default: {
        activities: Array.from({ length: 48 }, (_, i) => 0),
        tenPersonalItemInventory: Array.from({ length: 10 }, (_, i) => 0),
        wordDefinitions: Array.from({ length: 16 }, (_, i) => -1),
    }
})

export const whenAnsweredState = atom({
    key: 'whenAnsweredState',
    default: {
        activities: Array.from({ length: 48 }, (_, i) => 0),
        tenPersonalItemInventory: Array.from({ length: 10 }, (_, i) => 0),
        wordDefinitions: Array.from({ length: 16 }, (_, i) => -1),
    }
})

export const loadingState = atom({
    key: 'loadingState',
    default: false
})

export const progressState = atom({
    key: 'progressState',
    default: null
})